import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import ListForm from '../../../components/ListForm/ListForm.component';
import { DAFTAR_NILAI_FORM_FIELDS } from '../../../constants/kurikulum/ulangan.constant';
import { commaFormatted } from '../../../utils/transformer.util';
import { Button } from '../../../components/base/index';
import DaftarNilaiSiswaForm from './components/DaftarNilaiSiswaForm.component';

export default class DaftarNilaiSiswa extends PureComponent {
  constructor(props) {
    super(props);
    this._onFormChange = this._onFormChange.bind(this);
    this._onClickNext = this._onClickNext.bind(this);
    this.state = {
      form: {
        value: {},
        error: {},
      },
    };
  }

  _onFormChange(event) {
    const {
      name,
      value,
      dataset,
      files,
    } = event.target;
    const { inputType = 'text' } = dataset;
    this.setState((prevState) => {
      let formattedValue = value;
      if (inputType === 'number') {
        formattedValue = commaFormatted(value);
      }
      if (inputType === 'file') {
        [formattedValue] = files;
      }
      return {
        form: {
          value: {
            ...prevState.form.value,
            [name]: formattedValue,
          },
          error: {
            ...prevState.form.error,
            [name]: '',
          },
        },
      };
    });
  }

  _onClickNext() {
    const { history } = this.props;
    history.push('/dashboard/kesiswaan/laporan/daftar-siswa-kelas-unit');
  }


  render() {
    const { form } = this.state;
    return (

      <div className="student-list">
        <div className="budget__title">
          <h1>Daftar Nilai Siswa </h1>
          <hr />
        </div>
        <form onSubmit={this._onSubmit}>
          <ListForm
            form={form}
            formFields={DAFTAR_NILAI_FORM_FIELDS}
            onFormChange={this._onFormChange}
          />
        </form>
        <div className="result__content">
          <DaftarNilaiSiswaForm
            form={form}
            onFormChange={this._onFormChange}
          />
        </div>
        <div className="manage-registration__footer">
          <Button
            onClick={this._onClickSubmit}
            title="Submit"
          />
        </div>
      </div>

    );
  }
}
DaftarNilaiSiswa.propTypes = {
  handleGetKlapper: PropTypes.func,
  handleDeleteKlapper: PropTypes.func,
};
DaftarNilaiSiswa.defaultProps = {
  handleGetKlapper: noop,
  handleDeleteKlapper: noop,
};
